<template>
  <el-dialog
    title="关联业务机会"
    :visible.sync="dialogVisible"
    width="40%"
    class="businessOppDialog"
    @close="dialogCloseHandle"
  >
    <el-form class="common_form" label-position="left" ref="businessOppForm" :rules="rules" label-width="130px" :model="formData">
      <el-row>
        <el-col :span="24">
          <el-form-item label="客户单位名称">
            <el-input v-model="formData.accountName" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="CRM业务机会" prop="businessChanceId">
            <el-select v-model="formData.businessChanceId" clearable placeholder="请选择" filterable>
              <el-option
                v-for="(item, index) in businessChanceList"
                :key="index"
                :label="item.opportunityName"
                :value="item.opportunityNumber"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogCloseHandle">取消</el-button>
      <el-button type="primary" @click="submitHandlen">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { waitingProcessingApi } from '../../service';
import { arrayQuery } from '@/utils/utils';

export default {
  data () {
    return {
      rules: {
        businessChanceId: [
          { required: true, message: '请选择CRM业务机会', trigger: 'change' }
        ]
      },
      dialogVisible: false,
      formData: {},
      businessChanceList: []
    };
  },
  props: {
    businessOppShow: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    businessOppShow (val) {
      if (val) {
        this.formData.leadId = this.rowData.leadId;
        this.formData.accountName = this.rowData.unit;
        this.getBusinessChanceList();
      } else {
        this.formData = {};
      }
      this.dialogVisible = val;
    }
  },
  methods: {
    getBusinessChanceList () {
      waitingProcessingApi.getBusinessChanceList(this.rowData.crmCode).then((res) => {
        if (res.status === '200') {
          this.businessChanceList = res.data;
        }
      });
    },
    submitHandlen () {
      this.$refs['businessOppForm'].validate((valid) => {
        if (valid) {
          let businessObj = arrayQuery(this.formData.businessChanceId, this.businessChanceList, 'opportunityNumber');
          // console.log(businessObj);
          // this.formData.opportunityNumber = businessObj.opportunityNumber;
          this.formData.businessChanceName = businessObj.opportunityName;
          this.formData.predictType = businessObj.forecastCategoryName;
          this.formData.customerPurchaseStage = businessObj.purchaseStage;
          this.formData.flagStatus = businessObj.flagStatus;
          this.formData.actualOrderAmount = businessObj.realAmount;
          this.formData.cancelOrderReason = businessObj.cancellReasonExplain;
          this.formData.cancelOrderTime = businessObj.cancellDate;
          this.formData.predictOrderAmount = businessObj.estimatedAmount;
          this.$emit('submitHandle', this.formData);
        }
      });
    },
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    }
  }
};
</script>

<style lang="scss" scoped>
  .businessOppDialog {
    ::v-deep.el-dialog {
      margin-top: 20vh !important;

      .el-dialog__body {
        min-height: 240px;
      }
    }
  }
</style>
